module.exports = __webpack_public_path__ + "img/_DSC0544 2 3.c678eb2d.jpg";